import Endpoint from './endpoint'
import { API_URL } from './index'

export default class MailQueues extends Endpoint {
  async all(campaignId, page, sortBy = 'created_at', sortDirection = 'asc') {
    let url = new URL('/api/campaign_mail_queues', API_URL)
    url.searchParams.set('campaign_id', campaignId)
    url.searchParams.set('page', page)
    // url.searchParams.set('sort_by', sortBy)
    // url.searchParams.set('sort_direction', sortDirection)

    return this.request(url)
  }
}
